import { basics, basicsDescription } from "../../../basics";

const Warranty = () => {
  const descriprtion = basicsDescription.warranty.includes("\n");
  const paragraphs = descriprtion
    ? basicsDescription.warranty
        .split("\n")
        .map((paragraph: any, index: any) => {
          return <p key={index}>{paragraph}</p>;
        })
    : basicsDescription.warranty;
  return (
    <div className="my-24 max-w-[1400px] mx-auto">
      <div className="flex justify-center text-slate-800 font-bold text-lg">
        {basics.warranty}
      </div>
      <p className="text-slate-700 font-medium leading-loose text-justify m-3 sm:m-4">
        {paragraphs}
      </p>
    </div>
  );
};

export default Warranty;
